// Service worker disabled — admin dashboards must always load fresh deploys.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach(reg => reg.unregister());
  });
}
